module.exports = __webpack_public_path__ + "static/media/logo.5ecae4e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/logo.png
// module id = 664
// module chunks = 0